var scope_0 = require('/vercel/2beec658/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/048bdca41d224406ff37d8291e6925a4.js').default;export default
        Object.assign({}, scope_0 )
    